var _style, _switch;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMucLogoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 3000 3000",
    viewBox: "0 0 3000 3000",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:none;stroke:#283541;stroke-width:6;stroke-miterlimit:10;}\n\t.st1{display:none;fill:none;stroke:#283541;stroke-width:20;stroke-miterlimit:10;}\n\t.st2{fill:#878787;stroke:#283541;stroke-width:20;stroke-miterlimit:10;}\n\t.st3{stroke:#283541;stroke-width:20;stroke-miterlimit:10;}\n\t.st4{fill:#FAA31A;}\n\t.st5{fill:#9B9B9B;}\n\t.st6{fill:#0B1F31;}\n\t.st7{fill:#29343F;}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:#9B9A9A;stroke:#283541;stroke-width:20;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#283541;stroke-width:20;stroke-miterlimit:10;}\n\t.st11{fill:#FFFFFF;stroke:#283541;stroke-width:20;stroke-miterlimit:10;}\n\t.st12{fill:#283541;}\n\t.st13{fill:#A24E9E;}\n\t.st14{fill:#5BBA47;}\n\t.st15{fill:#00B8ED;}\n\t.st16{fill:#F26939;}\n\t.st17{fill:#878787;stroke:#283541;stroke-width:10;stroke-miterlimit:10;}\n\t.st18{stroke:#283541;stroke-width:10;stroke-miterlimit:10;}\n\t.st19{fill:#9B9A9A;stroke:#283541;stroke-width:10;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#283541;stroke-width:10;stroke-miterlimit:10;}\n\t.st21{fill:#FFFFFF;stroke:#283541;stroke-width:10;stroke-miterlimit:10;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 2424.7,
    cy: 937.14,
    r: 441.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 2423.7,
    cy: 936.08,
    r: 347.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 6515.2,
    cy: 971.29,
    r: 1350.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 6512,
    cy: 968.06,
    r: 1062.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "5889.8 875.54 5889.8 946.02 6047.9 858.32 6206.2 946.02 6206.2 876.04 6048 787.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "5969.4 921.09 6048 878.14 6125.4 921.09 6048 966.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "5889.8 964.82 5889.8 1056.8 5951.2 1024.1 5951.2 930.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "6206.2 964.82 6206.2 1057.4 6143.7 1023.2 6143.7 930.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "6048 1058.4 6125.4 1014.8 6125.4 921.09 6048 966.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "6048 1080.6 6048 1150 6206.2 1057.4 6143.7 1023.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "5951.2 1024.1 6048 1080.6 6048 1150 5889.8 1056.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "5969.4 921.09 5969.4 1013.9 6048 1058.4 6048 966.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m6295.2-361.23l235.72 266.54s-626.92 0-902.73 472c-237.39 406.26-179.16 637.49-179.16 637.49l-250.21 258.91s-135.36-443.37 108.1-906.03c341.42-648.8 988.28-728.91 988.28-728.91z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6521.2,
    cy: 977.24,
    r: 1093.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.845 -.5348 .5348 .845 7130.9 2079)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 146.54,
    y: -1,
    rotate: -5.79
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 250.62,
    y: -11.17,
    rotate: -10.86
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 371.1,
    y: -32.47,
    rotate: -17.79
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 554.63,
    y: -93.64,
    rotate: -25.53
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 687.4,
    y: -156.8,
    rotate: -32.82
  }, "H")), /*#__PURE__*/React.createElement("circle", {
    cx: 6521.2,
    cy: 977.24,
    r: 1093.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.9299 .3677 -.3677 .9299 6876.3 -104.85)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8913 .4534 -.4534 .8913 6989.6 -60.015)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "e"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8512 .5248 -.5248 .8512 7073.2 -18.077)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "a"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8183 .5748 -.5748 .8183 7152.5 31.239)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "l"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.7605 .6493 -.6493 .7605 7190.1 53.251)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.6708 .7416 -.7416 .6708 7321.7 167.09)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.5876 .8092 -.8092 .5876 7401 253.73)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.4977 .8674 -.8674 .4977 7474.6 354.45)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "X"), /*#__PURE__*/React.createElement("circle", {
    cx: 6516.7,
    cy: 979.38,
    r: 1103.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.229 -.9734 .9734 .229 5379.5 805.48)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "190.96px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 173.11,
    y: 1.69,
    rotate: 6.77
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 268.68,
    y: 12.29,
    rotate: 11.94
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 376.22,
    y: 34.24,
    rotate: 17.71
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 492.1,
    y: 71.41,
    rotate: 23.07
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 581.27,
    y: 107.65,
    rotate: 28.89
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 702.14,
    y: 174,
    rotate: 35.52
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 805.48,
    y: 247.42,
    rotate: 41.63
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 892.69,
    y: 323.75,
    rotate: 47.72
  }, "A")), /*#__PURE__*/React.createElement("circle", {
    cx: 6515.2,
    cy: 971.29,
    r: 1109.4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.5393 .8421 -.8421 .5393 5393.3 1579.3)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 178.79,
    y: -2.73,
    rotate: -5.01
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 203.36,
    y: -2.59,
    rotate: -8.44
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 330.05,
    y: -22.2,
    rotate: -11.86
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 364.25,
    y: -27.39,
    rotate: -15.5
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 487.44,
    y: -62.61,
    rotate: -19.14
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 526.22,
    y: -74.9,
    rotate: -22.34
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 638.3,
    y: -121.61,
    rotate: -27.7
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 741.57,
    y: -176.35,
    rotate: -32.96
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 835.13,
    y: -237.17,
    rotate: -38.11
  }, "S")), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 6530.9,
    x2: 6295.2,
    y1: -94.69,
    y2: -361.23
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(6220.3 1103.7)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "369.96px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 0,
    y: 0,
    letterSpacing: -4
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 350.35,
    y: 0,
    letterSpacing: -28
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 617.08,
    y: 0,
    letterSpacing: 12
  }, "C")), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 6577.8,
    y: 1074.8,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 6824.7,
    y: 1074.8,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 7096.6,
    y: 1074.8,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m5465.3 1154.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m6431 2027.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 6443.1,
    x2: 6719,
    y1: 2031,
    y2: 2306.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 5198.8,
    x2: 5449,
    y1: 1273.7,
    y2: 1014.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 7574.8,
    x2: 7842.4,
    y1: 982.48,
    y2: 735.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 6515.2,
    cy: 971.29,
    r: 1350.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 6512,
    cy: 968.06,
    r: 1062.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 1499.8,
    cy: 1499.7,
    r: 1350.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1496.6,
    cy: 1496.7,
    r: 1063
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "874.55 1403.9 874.55 1474.3 1032.5 1386.7 1190.6 1474.3 1190.6 1404.4 1032.6 1315.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "954.05 1449.5 1032.6 1406.5 1110 1449.5 1032.6 1494.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "874.55 1493.4 874.55 1584.8 935.55 1552.3 935.55 1459.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1190.6 1493.4 1190.6 1585.4 1128.6 1551.4 1128.6 1459.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1032.6 1586.4 1109.6 1543.1 1109.6 1449.9 1032.6 1495"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "1032.6 1609 1032.6 1678.4 1190.8 1585.8 1128.3 1551.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "935.77 1552.5 1032.6 1609 1032.6 1678.4 874.34 1585.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "953.55 1449.1 953.55 1542.4 1032.6 1587.1 1032.6 1494.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2109.7 2447.9c20.11-12.73 49.09-19.71 58.23-5.28l8.93 14.11-14.92 9.44-5.34-8.43c-6.06-9.57-24.12-4.72-37.58 3.8-26.76 16.94-32.13 45.79-15.5 72.06 16.74 26.44 46.25 35.02 73.18 17.98 10.22-6.47 28.71-22.49 21.62-33.68l-9.55-15.08-22.38 14.17-8.01-12.65 37.31-23.61 20.33 32.12c11.19 17.68-14.33 42.69-31.52 53.58-35.2 22.28-76.07 12.26-97.53-21.64-21.48-33.92-12.96-74.3 22.73-96.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2221.8 2415.1c21.75-17.06 45.64-9.94 61.16 9.84 1.54 1.96 3.93 5.94 3.93 5.94l-55.88 43.85c14.18 16.2 33.22 15.9 46.81 5.24 13.29-10.43 16.05-26.5 16.05-26.5l14.46 5.98s-3.18 19.58-21.46 33.92c-24.01 18.84-54.1 14.39-71.88-8.26-19.07-24.32-14.93-52.95 6.81-70.01zm43.1 17.92c-11-13.09-24.61-13.64-34.27-6.05-11.18 8.77-14.31 23.43-6.35 37.93l40.62-31.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2297 2350.3c21.13-19.84 52.79-20.34 72.9 1.07 20.24 21.55 17.88 53.26-3.25 73.1s-52.92 20.2-73.16-1.35c-20.11-21.41-17.62-52.97 3.51-72.82zm58.61 62.42c13.29-12.48 14.36-33.5 0.44-48.34-13.8-14.69-34.71-14.81-48-2.33-13.44 12.61-14.5 33.36-0.7 48.05 13.92 14.85 34.83 15.24 48.26 2.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m2403.1 2368.1l10.86-12.94-75.49-74.59-11.1 13.24-11.33-9.5 24.67-29.42 85.58 26.43c5.62 1.96 9.48 3.94 9.48 3.94l0.25-0.29s-2.62-3.45-5.53-8.64l-40.92-79.67 24.67-29.42 11.33 9.5-11.1 13.24 86.6 61.36 10.86-12.94 11.47 9.62-33.56 40.01-11.47-9.62 10.49-12.5-66.02-47.35c-3.36-2.57-8.16-7.6-8.16-7.6l-0.37 0.44s4.01 5.37 5.97 9.02l34.58 69.6-10.86 12.94-74.56-21.94c-3.93-1.29-9.92-4.31-9.92-4.31l-0.37 0.44s5.79 3.85 8.9 6.71l58.12 56.77 10.49-12.5 11.47 9.62-33.56 40.01-11.47-9.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m2521 2224l6.97-11.04-78.91-100.86 11.58-18.34 125 27.8 6.97-11.04 12.66 7.99-25.1 39.78-12.66-7.99 7.68-12.18-31.12-7.15-25.61 40.59 19.85 25.01 7.79-12.34 12.66 7.99-25.1 39.78-12.66-8zm7.51-97.17l-48.58-11.14c-5.73-1.35-10-3.58-10-3.58l-0.31 0.49s3.75 3.05 7.54 7.48l30.86 39.22 20.49-32.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m2601.9 2094l7.13-15.31-95.9-44.64-7.13 15.31-13.4-6.24 22.44-48.21 13.4 6.24-7.21 15.49 40.9 19.04 29.65-63.7-40.9-19.04-7.21 15.49-13.4-6.24 22.44-48.21 13.4 6.24-7.13 15.31 95.9 44.64 7.13-15.31 13.57 6.32-22.44 48.21-13.57-6.32 7.21-15.49-40.72-18.96-29.65 63.7 40.72 18.96 7.21-15.49 13.58 6.32-22.44 48.21-13.58-6.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1875.9 413.37l15.71 6.21 38.89-98.36-15.71-6.22 5.43-13.75 54.63 21.6c8.93 3.53 16.11 6.78 22.15 11.85 11.45 9.69 15.82 24.21 9.04 41.35-7.2 18.21-22.35 27.29-40.04 25.04l-0.14 0.36s2.51 3.06 3.03 8.01l5.57 38.12c0.62 4.17 2.66 5.8 7.12 7.57l3.75 1.48-5.5 13.92-10.71-4.23c-10.71-4.24-12.43-7.19-13.75-16.38l-5.84-42.15c-1.1-6.63-2.78-9.15-10.46-12.19l-15-5.93-14.61 36.95 15.53 6.14-5.5 13.92-49.09-19.41 5.5-13.9zm79.31-28.3c13.75 5.43 26.38 0.11 32.24-14.71 3.88-9.82 2.64-18.16-3.95-24.47-3.47-3.23-8.54-6.06-14.61-8.46l-20.89-8.26-18.14 45.88 25.35 10.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2067.5 404.29c24.66 12.49 28.31 37.15 16.95 59.58-1.13 2.23-3.72 6.08-3.72 6.08l-63.37-32.09c-8.69 19.7-0.36 36.83 15.05 44.64 15.07 7.63 30.8 3.33 30.8 3.33l0.69 15.63s-19.09 5.4-39.81-5.1c-27.23-13.79-35.93-42.94-22.92-68.63 13.98-27.57 41.66-35.93 66.33-23.44zm1.99 46.63c7.21-15.5 1.95-28.06-9.01-33.61-12.67-6.42-27.29-3.06-37.06 10.28l46.07 23.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2140.8 491.35l5.24 3.21 1.91-3.11c8.04-13.09 3.32-22.29-6.82-28.52-13.09-8.03-28.64-6.55-28.64-6.55l0.55-15.21s18.13-2.38 37.44 9.47c21.1 12.96 25.5 30.75 12.64 51.69l-22.7 36.97c-1.51 2.45-0.9 4.4 1.39 5.81l8.34 5.12-7.53 12.27-16.52-10.15c-7.36-4.52-8.1-9.93-4.78-15.33l0.7-1.14c2.01-3.27 3.97-5 3.97-5l-0.33-0.2s-17.95 13.09-38.07 0.73c-13.74-8.44-22.56-24.89-12.12-41.91 15.97-25.98 51.59-6.58 65.33 1.85zm-42.25 29.93c14.07 8.64 31.58-0.44 39.21-12.87l2.11-3.43-4.09-2.51c-7.53-4.62-33.74-20.26-43.48-4.39-4.52 7.35-3.24 17.38 6.25 23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2217.1 467.86l-13.22-9.23 8.24-11.8 28.49 19.89-61.1 87.51c-4.72 6.77-6.34 12.43 0.59 17.27 2.52 1.76 4.36 2.81 4.36 2.81l-8.95 12.48s-3.37-1.88-6.99-4.41c-11.33-7.91-17.9-19.29-4.94-37.86l53.52-76.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m2187.4 573.06l12.88 10.93 75.04-75.04-13.17-11.18 9.57-11.27 29.27 24.85-26.94 85.42c-1.99 5.61-3.99 9.45-3.99 9.45l0.29 0.25s3.46-2.6 8.68-5.47l79.91-40.44 29.27 24.85-9.57 11.27-13.17-11.18-61.87 86.23 12.88 10.93-9.69 11.42-39.81-33.79 9.69-11.42 12.44 10.56 47.75-65.73c2.59-3.34 7.64-8.12 7.64-8.12l-0.44-0.37s-5.4 3.98-9.05 5.91l-69.8 34.17-12.88-10.93 22.39-74.42c1.31-3.92 4.37-9.89 4.37-9.89l-0.44-0.37s-3.89 5.76-6.77 8.86l-57.11 57.78 12.44 10.56-9.69 11.42-39.81-33.79 9.69-11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m2340 710.53l11.5 12.64 77.53-70.54-21.44-23.57-15.62 14.21-11.24-12.35 27.26-24.8 78.29 86.05-27.26 24.8-11.24-12.35 15.62-14.21-21.45-23.57-77.53 70.54 11.5 12.64-11.08 10.08-35.91-39.48 11.07-10.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m2401.6 778.97l9.97 13.64 85.41-62.4-9.97-13.64 11.94-8.72 34.65 47.43c5.66 7.75 10 14.33 12.4 21.85 4.51 14.3 0.44 28.92-14.44 39.79-15.81 11.55-33.47 11.14-47.23-0.21l-0.31 0.23s0.49 3.92-1.72 8.39l-15.65 35.21c-1.7 3.86-0.85 6.33 1.98 10.2l2.38 3.25-12.09 8.83-6.79-9.3c-6.79-9.3-6.68-12.72-2.88-21.19l17.57-38.75c2.61-6.19 2.53-9.22-2.33-15.89l-9.51-13.02-32.09 23.44 9.85 13.49-12.09 8.83-31.14-42.63 12.09-8.83zm82.17 18.42c8.72 11.94 22.25 14.18 35.11 4.78 8.53-6.23 11.92-13.94 9.73-22.8-1.21-4.58-3.99-9.69-7.84-14.96l-13.25-18.13-39.84 29.11 16.09 22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m2473.2 877.6l6.34 10.97 63.85 3.47 28.03-55.87-6.24-10.8 12.8-7.39 23.62 40.89-12.8 7.39-7.2-12.47-19.52 37.21c-1.44 3.27-2.93 5.68-2.93 5.68l0.19 0.33s2.74-0.25 6.29 0.14l41.6 1.02-7.01-12.13 12.8-7.39 22.95 39.73-12.8 7.39-6.34-10.97-64.28-3.44-27.6 55.84 6.43 11.14-12.97 7.49-23.62-40.9 12.97-7.49 7.11 12.3 19.26-37.28c1.6-3.37 3.09-5.78 3.09-5.78l-0.19-0.33c-0.1-0.17-2.74 0.25-6.36 0.12l-41.53-1.28 7.11 12.3-12.97 7.49-23.04-39.9 12.96-7.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m351.26 1323.4l3.85-16.36-100.45-32.46-3.94 16.73-14.31-3.37 8.75-37.18 87.84-14.84c5.87-0.78 10.18-0.74 10.18-0.74l0.09-0.37s-3.87-1.89-8.78-5.21l-72.01-52.45 8.75-37.18 14.31 3.37-3.94 16.73 104.39 15.73 3.85-16.36 14.5 3.41-11.89 50.56-14.5-3.41 3.72-15.8-79.84-12.5c-4.13-0.78-10.65-3.09-10.65-3.09l-0.13 0.56s5.97 2.97 9.34 5.34l61.88 46.34-3.85 16.36-76.05 13.89c-4.07 0.61-10.74 0.61-10.74 0.61l-0.13 0.56s6.87 0.83 10.91 1.98l77.04 24.4 3.72-15.8 14.5 3.41-11.89 50.56-14.52-3.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m371.02 1086.6l2.09-5.74-3.41-1.24c-14.36-5.23-22.39 1.2-26.44 12.32-5.23 14.35-0.68 29.22-0.68 29.22l-14.93 2.49s-5.93-17.2 1.78-38.37c8.43-23.15 24.9-30.97 47.86-22.61l40.55 14.77c2.69 0.98 4.47 0 5.38-2.51l3.33-9.15 13.46 4.9-6.6 18.12c-2.94 8.08-8.06 9.87-13.99 7.71l-1.26-0.46c-3.59-1.31-5.66-2.88-5.66-2.88l-0.13 0.36s16.32 14.89 8.29 36.96c-5.49 15.07-19.77 26.94-38.43 20.15-28.52-10.39-16.7-48.97-11.21-64.04zm37.57 35.23c5.62-15.43-6.71-30.69-20.34-35.66l-3.77-1.37-1.63 4.49c-3.01 8.25-13.04 36.92 4.37 43.25 8.07 2.94 17.58-0.3 21.37-10.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m480.83 1040.6c7.15-15.21 6.09-30.9-11.89-39.35l-6.91-3.25c-2.76-1.3-5.29-3.12-5.29-3.12l-0.16 0.35c6.21 9.25 7.83 20.14 1.82 32.93-11.37 24.19-37.89 29.88-63.12 18.01-25.06-11.78-37.14-34.55-25.69-58.92 5.36-11.41 15.37-21.47 27.67-21.6l0.16-0.34s-1.37-0.22-3.62-1.28c-5.53-2.6-7.51-6.91-4.1-14.17l8.78-18.67 12.96 6.09-4.55 9.68c-1.06 2.25-0.58 4.37 1.67 5.43l67.4 31.69c28.86 13.57 29.6 40.71 19.2 62.83-4.96 10.54-12.93 19.88-21.31 26.49l-10.19-11.54s11-8.13 17.17-21.26zm-54.58-59.85c-22.81-10.72-34.58-2.75-41 10.9-7.07 15.04-0.07 28.88 17.73 37.25 18.15 8.53 35.06 4.87 42.45-10.85 5.69-12.1 3.63-26.57-19.18-37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m476.01 960.26l7.76-12.94-54.7-32.8c-2.46-1.47-4.39-0.85-5.76 1.44l-6.09 10.15-12.28-7.37 11.2-18.67c4.32-7.21 9.4-8.62 15.46-4.98l4.26 2.55c2.62 1.57 4.46 3.34 4.46 3.34l0.2-0.33c-3.44-4.29-13.37-23.38-0.79-44.34 11.39-19 27.14-21.13 48.27-8.46l40.78 24.46 7.86-13.1 12.28 7.37-17.38 28.99-49.46-29.66c-11.63-6.97-22.17-10.18-30.13 3.08-10.02 16.7-1.37 36.81 15.17 46.73l26.2 15.71 7.86-13.1 12.28 7.37-25.14 41.92-12.31-7.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m535.52 785.56l3.62-4.92-2.92-2.15c-12.31-9.04-21.82-5.13-28.83 4.41-9.04 12.31-8.85 27.85-8.85 27.85l-15.03-1.8s-0.87-18.17 12.48-36.33c14.59-19.85 32.58-22.74 52.28-8.27l34.78 25.55c2.31 1.7 4.29 1.26 5.87-0.9l5.77-7.85 11.54 8.48-11.42 15.54c-5.09 6.93-10.51 7.21-15.59 3.48l-1.08-0.79c-3.08-2.26-4.62-4.35-4.62-4.35l-0.23 0.31s11.49 18.87-2.42 37.8c-9.5 12.93-26.54 20.31-42.54 8.55-24.48-17.97-2.31-51.68 7.19-64.61zm26.17 44.35c9.72-13.23 2.17-31.34-9.52-39.93l-3.23-2.37-2.83 3.85c-5.2 7.08-22.87 31.77-7.94 42.74 6.92 5.08 16.96 4.64 23.52-4.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m597.72 775.2l11.28-12.46-78.04-70.59-11.27 12.46-10.9-9.86 38.56-42.63c7.56-8.36 13.62-14.2 21.62-19.07 23.24-13.74 51.79-10.57 76.15 11.46 24.22 21.91 30.18 49.19 18.74 74.37-3.77 8.44-9.22 15.61-16.4 23.54l-38.69 42.77-11.05-9.99zm37.36-42.43c5.89-6.51 10.19-12.41 12.82-19.3 7.5-17.68 2.17-37.7-16.1-54.22-18.41-16.65-38.86-19.96-55.71-11-6.98 3.73-11.87 8.57-17.77 15.09l-13.83 15.29 76.76 69.43 13.83-15.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m683.94 679.68l9.74-8.58-47.04-118.38 16.19-14.27 111.52 61.57 9.74-8.58 9.85 11.17-35.1 30.93-9.85-11.18 10.75-9.47-27.7-15.55-35.82 31.56 11.94 29.44 10.89-9.6 9.85 11.18-35.1 30.93-9.86-11.17zm34.41-90.64l-43.25-24.24c-5.09-2.89-8.54-6.22-8.54-6.22l-0.43 0.38s2.73 3.96 5.1 9.25l18.46 46.09 28.66-25.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m800.85 580.59l13.79-9.93-60.94-84.61-25.72 18.53 12.28 17.04-13.48 9.71-21.43-29.75 93.91-67.63 21.43 29.75-13.48 9.71-12.28-17.05-25.72 18.53 60.94 84.61 13.79-9.93 8.71 12.09-43.08 31.03-8.72-12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m859.51 537.11l11.23-6.52-23.09-125.28 18.66-10.84 97.39 82.12 11.23-6.52 7.48 12.88-40.46 23.5-7.48-12.88 12.38-7.19-24.14-20.65-41.28 23.98 5.98 31.2 12.55-7.29 7.48 12.88-40.46 23.5-7.47-12.89zm51.41-82.2l-37.7-32.21c-4.43-3.83-7.16-7.77-7.16-7.77l-0.5 0.29s1.9 4.42 3.2 10.07l9.13 48.8 33.03-19.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m394.45 2105.8l9.11 14.23 93.74-49.77-9.32-14.55 12.45-7.97 20.71 32.33-50.78 73.78c-3.55 4.78-6.59 7.87-6.59 7.87l0.21 0.32s4.07-1.47 9.9-2.69l88.26-15.25 20.71 32.33-12.45 7.97-9.32-14.55-84.42 64.32 9.11 14.23-12.61 8.08-28.16-43.97 12.61-8.07 8.8 13.74 64.91-48.86c3.45-2.44 9.69-5.52 9.69-5.52l-0.31-0.48s-6.33 2.23-10.39 3l-76.75 12.22-9.11-14.23 43.21-64.6c2.4-3.36 7.07-8.18 7.07-8.18l-0.31-0.49s-5.41 4.37-9.07 6.49l-71.54 38.52 8.8 13.74-12.61 8.07-28.16-43.97 12.61-8.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m501.49 2256.1l12.2 15.81-15.96 12.31-12.2-15.81 15.96-12.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m593.53 2212.6l-11.18-12.92 11.18-9.67 34.93 40.35-11.18 9.68-11.18-12.92-52.98 45.86c-6.68 5.78-11.35 12.11-13.3 18.37-3.03 9.99 0.1 21.24 8.65 31.11 8.42 9.72 19.23 14.58 29.84 12.76 6.34-1.18 13.26-4.63 19.94-10.41l52.83-45.74-11.18-12.92 11.18-9.68 34.8 40.2-11.18 9.67-11.06-12.77-53.12 45.99c-9.72 8.42-20.84 13.47-31.12 14.5-15.9 1.58-31.79-6.51-43.85-20.44-12.56-14.51-17.6-31.48-14.2-46.61 2.38-10.44 9.19-19.89 19.06-28.43l53.12-45.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m593.26 2363.8l13.89 14.34-14.47 14.03-13.89-14.34 14.47-14.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m740.23 2342.7c12.05 11 34.13 39.21 20.02 54.66l-11.13 12.19-13.19-12.04 7.12-7.8c8.02-8.79-4.17-25.9-13.39-34.31-21.41-19.54-51.51-18.17-72.22 4.51-21.61 23.68-20.85 55.31 0.98 75.23 7.09 6.47 27.28 20.23 35.7 11.01l7.12-7.8 13.19 12.04-11.13 12.19c-13.46 14.75-43.08-3.2-56.98-15.88-30.06-27.44-30.66-70.35-4-99.55 26.8-29.33 68.99-30.85 97.91-4.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m708.49 2470.4l15.57 12.5-12.62 15.72-15.57-12.5 12.62-15.72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m761.81 2486.4l-5.8 8.12c-5.8 8.12 1.2 20.44 12.76 28.7 12.65 9.04 26.11 9.69 33.92-1.25 9.15-12.81-0.8-26.29-10.6-41.31-10.62-15.85-21-32.7-7.05-52.22 14.84-20.77 37.92-17.74 56.51-4.46 16.56 11.83 28.96 30.13 20.37 42.16l-9.26 12.97-14.53-10.38 5.47-7.65c4.58-6.4-2.81-16.87-11.87-23.34-10.78-7.7-22.94-8.84-30.19 1.31-8.37 11.71-0.07 23.54 8.92 37.05 11.89 17.7 23.52 35.44 8.9 55.9-15.07 21.09-40.06 19.75-60.52 5.13-17.18-12.28-30.93-33.66-19.66-49.43l8.26-11.56 14.37 10.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m899.11 2553.5l5.31 3.09 1.83-3.15c7.72-13.27 2.79-22.36-7.49-28.34-13.27-7.72-28.79-5.87-28.79-5.87l0.19-15.21s18.07-2.81 37.65 8.58c21.41 12.45 26.22 30.13 13.86 51.37l-21.82 37.5c-1.45 2.49-0.8 4.42 1.53 5.77l8.46 4.92-7.24 12.44-16.76-9.75c-7.47-4.34-8.33-9.73-5.14-15.21l0.68-1.16c1.93-3.32 3.85-5.09 3.85-5.09l-0.33-0.19s-17.63 13.51-38.04 1.63c-13.94-8.11-23.14-24.35-13.11-41.61 15.35-26.38 51.42-7.83 65.36 0.28zm-41.53 30.91c14.27 8.3 31.56-1.18 38.9-13.79l2.03-3.48-4.15-2.41c-7.63-4.44-34.21-19.46-43.57-3.36-4.35 7.45-2.83 17.44 6.79 23.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m998.18 2604.2l5.57 2.59 1.54-3.31c6.47-13.93 0.73-22.52-10.06-27.54-13.93-6.47-29.21-3.2-29.21-3.2l-1.21-15.17s17.74-4.46 38.28 5.09c22.46 10.44 28.87 27.6 18.52 49.88l-18.29 39.34c-1.21 2.61-0.39 4.48 2.05 5.61l8.88 4.13-6.07 13.06-17.58-8.17c-7.83-3.64-9.19-8.93-6.52-14.67l0.57-1.22c1.62-3.48 3.37-5.42 3.37-5.42l-0.35-0.16s-16.32 15.07-37.73 5.11c-14.62-6.8-25.28-22.12-16.87-40.23 12.87-27.67 50.49-12.51 65.11-5.72zm-38.52 34.6c14.97 6.96 31.32-4.07 37.47-17.3l1.7-3.66-4.35-2.02c-8.01-3.72-35.85-16.24-43.7 0.65-3.64 7.83-1.21 17.63 8.88 22.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m1057.1 2649.9l-3.38 9.39c-3.38 9.39 6.71 19.35 20.08 24.16 14.63 5.26 27.76 2.23 32.31-10.41 5.33-14.81-7.91-25.08-21.41-36.88-14.52-12.37-29.08-25.76-20.96-48.34 8.64-24.02 31.67-27.37 53.17-19.63 19.15 6.89 36.05 21.13 31.05 35.04l-5.39 14.99-16.8-6.04 3.18-8.85c2.66-7.41-7.29-15.47-17.76-19.24-12.46-4.49-24.48-2.28-28.7 9.46-4.87 13.55 6.33 22.68 18.65 33.23 16.25 13.8 32.26 27.72 23.74 51.38-8.77 24.39-33.19 29.88-56.85 21.37-19.87-7.15-38.9-23.99-32.34-42.24l4.81-13.37 16.6 5.98z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1515.5,
    x2: 1279.8,
    y1: 433.71,
    y2: 167.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1219 1603.2h32.56l16.65-203.84h-33.3v-28.49h73.99l66.96 159.08c4.07 10.73 5.92 18.87 5.92 18.87h0.74s1.85-8.14 5.92-18.87l66.96-159.08h73.99v28.49h-33.29l16.65 203.84h32.56v28.86h-100.63v-28.86h31.45l-11.84-156.12c-0.37-8.14 1.11-21.46 1.11-21.46h-1.11s-2.96 12.58-5.92 19.98l-59.93 137.25h-32.56l-59.93-137.25c-2.96-7.4-5.92-19.98-5.92-19.98h-1.11s1.48 13.32 1.11 21.46l-11.84 156.12h31.45v28.86h-100.63v-28.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1599.7 1399.4h-32.92v-28.49h102.85v28.49h-32.93v135.03c0 17.02 3.33 31.82 9.99 42.54 10.73 17.02 31.08 26.63 56.23 26.63 24.79 0 45.5-9.62 56.23-27.38 6.29-10.73 9.99-25.16 9.99-42.17v-134.66h-32.93v-28.49h102.48v28.49h-32.56v135.4c0 24.79-6.66 47.35-18.13 63.63-17.76 25.16-49.57 38.1-85.09 38.1-36.99 0-68.07-14.06-85.83-38.1-12.21-16.65-17.39-38.47-17.39-63.63v-135.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m1971.8 1366.5c31.45 0 99.52 11.47 99.52 51.79v31.82h-34.41v-20.35c0-22.94-39.58-31.45-63.63-31.45-55.86 0-96.93 41.06-96.93 100.26 0 61.78 42.17 105.8 99.15 105.8 18.5 0 65.11-6.66 65.11-30.71v-20.35h34.41v31.82c0 38.47-65.48 51.42-101.74 51.42-78.43 0-135.03-60.3-135.03-136.51 0-76.57 58.08-133.54 133.55-133.54z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 1562.6,
    y: 1602.7,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 1809.6,
    y: 1602.7,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 2081.6,
    y: 1602.7,
    width: 29,
    height: 29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m449.92 1682.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m1415.6 2556.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 1427.7,
    x2: 1703.6,
    y1: 2559.4,
    y2: 2834.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 183.45,
    x2: 433.65,
    y1: 1802.1,
    y2: 1543.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 2559.4,
    x2: 2827,
    y1: 1510.9,
    y2: 1264.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1500,
    cy: 1500.2,
    r: 1350.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 1496.6,
    cy: 1496.7,
    r: 1063
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -3191.7,
    cy: 5577.5,
    r: 1350.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: -3194.9,
    cy: 5574.2,
    r: 1062.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-3817.1 5481.7 -3817.1 5552.2 -3659 5464.5 -3500.7 5552.2 -3500.7 5482.2 -3658.9 5393.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-3737.4 5527.3 -3658.9 5484.3 -3581.5 5527.3 -3658.9 5572.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-3817.1 5571 -3817.1 5663 -3755.7 5630.3 -3755.7 5536.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-3500.7 5571 -3500.7 5663.6 -3563.2 5629.4 -3563.2 5536.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-3658.9 5664.5 -3581.5 5621 -3581.5 5527.3 -3658.9 5572.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-3658.9 5686.8 -3658.9 5756.1 -3500.7 5663.6 -3563.2 5629.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "-3755.7 5630.3 -3658.9 5686.8 -3658.9 5756.1 -3817.1 5663"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "-3737.4 5527.3 -3737.4 5620.1 -3658.9 5664.5 -3658.9 5572.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m-3263.8 6637.2l275.89 275.38s580.93-77.34 923.38-591.23c317.15-475.92 199.96-979.15 199.96-979.15l-267.55 246.5s42.61 360.23-285.76 710.82c-362.86 387.4-845.92 337.68-845.92 337.68z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -3185.7,
    cy: 5583.4,
    r: 1093.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.845 -.5348 .5348 .845 -2576 6685.2)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 146.54,
    y: -1,
    rotate: -5.79
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 250.62,
    y: -11.17,
    rotate: -10.86
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 371.1,
    y: -32.47,
    rotate: -17.79
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 554.63,
    y: -93.64,
    rotate: -25.53
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 687.4,
    y: -156.8,
    rotate: -32.82
  }, "H")), /*#__PURE__*/React.createElement("circle", {
    cx: -3185.7,
    cy: 5583.4,
    r: 1093.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.9299 .3677 -.3677 .9299 -2830.5 4501.3)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8913 .4534 -.4534 .8913 -2717.3 4546.2)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "e"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8512 .5248 -.5248 .8512 -2633.7 4588.1)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "a"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8183 .5748 -.5748 .8183 -2554.4 4637.4)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "l"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.7605 .6493 -.6493 .7605 -2516.8 4659.4)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.6708 .7416 -.7416 .6708 -2385.2 4773.3)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.5876 .8092 -.8092 .5876 -2305.9 4859.9)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.4977 .8674 -.8674 .4977 -2232.3 4960.6)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "X"), /*#__PURE__*/React.createElement("circle", {
    cx: -3190.2,
    cy: 5585.6,
    r: 1103.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.229 -.9734 .9734 .229 -4327.4 5411.7)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "190.96px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 173.11,
    y: 1.69,
    rotate: 6.77
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 268.68,
    y: 12.29,
    rotate: 11.94
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 376.22,
    y: 34.24,
    rotate: 17.71
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 492.1,
    y: 71.41,
    rotate: 23.07
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 581.27,
    y: 107.65,
    rotate: 28.89
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 702.14,
    y: 174,
    rotate: 35.52
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 805.48,
    y: 247.42,
    rotate: 41.63
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 892.69,
    y: 323.75,
    rotate: 47.72
  }, "A")), /*#__PURE__*/React.createElement("circle", {
    cx: -3191.7,
    cy: 5577.5,
    r: 1109.4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.5393 .8421 -.8421 .5393 -4313.6 6185.5)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 178.79,
    y: -2.73,
    rotate: -5.01
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 203.36,
    y: -2.59,
    rotate: -8.44
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 330.05,
    y: -22.2,
    rotate: -11.86
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 364.25,
    y: -27.39,
    rotate: -15.5
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 487.44,
    y: -62.61,
    rotate: -19.14
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 526.22,
    y: -74.9,
    rotate: -22.34
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 638.3,
    y: -121.61,
    rotate: -27.7
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 741.57,
    y: -176.35,
    rotate: -32.96
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 835.13,
    y: -237.17,
    rotate: -38.11
  }, "S")), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: -3176,
    x2: -3411.7,
    y1: 4511.5,
    y2: 4245
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-3486.6 5709.9)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "369.96px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 0,
    y: 0,
    letterSpacing: -4
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 350.35,
    y: 0,
    letterSpacing: -28
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 617.08,
    y: 0,
    letterSpacing: 12
  }, "C")), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: -3129.1,
    y: 5681,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: -2882.2,
    y: 5681,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: -2610.3,
    y: 5681,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m-4241.6 5760.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m-3275.9 6634.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: -3263.8,
    x2: -2987.9,
    y1: 6637.2,
    y2: 6912.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: -4508,
    x2: -4257.8,
    y1: 5879.9,
    y2: 5621
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: -2132.1,
    x2: -1864.5,
    y1: 5588.7,
    y2: 5342.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -3191.7,
    cy: 5577.5,
    r: 1350.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: -3194.9,
    cy: 5574.2,
    r: 1062.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 8908.3,
    cy: 6776.7,
    r: 1350.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 8905.1,
    cy: 6773.5,
    r: 1062.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "8282.9 6681 8282.9 6751.4 8441 6663.8 8599.3 6751.4 8599.3 6681.5 8441.1 6592.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "8362.5 6726.5 8441.1 6683.6 8518.5 6726.5 8441.1 6771.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "8282.9 6770.3 8282.9 6862.3 8344.3 6829.5 8344.3 6735.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "8599.3 6770.3 8599.3 6862.9 8536.8 6828.6 8536.8 6735.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "8441.1 6863.8 8518.5 6820.2 8518.5 6726.5 8441.1 6771.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "8441.1 6886 8441.1 6955.4 8599.3 6862.9 8536.8 6828.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "8344.3 6829.5 8441.1 6886 8441.1 6955.4 8282.9 6862.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "8362.5 6726.5 8362.5 6819.3 8441.1 6863.8 8441.1 6771.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m7842.1 6820.2s7.83 439.12 362.18 752.51c264.93 234.3 631.88 263.68 631.88 263.68l275.89 275.38s-626.72 130.92-1123.8-346.64c-329.49-316.52-396.32-686.02-396.32-686.02l250.2-258.91z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8914.2,
    cy: 6782.7,
    r: 1093.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.845 -.5348 .5348 .845 9524 7884.5)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 146.54,
    y: -1,
    rotate: -5.79
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 250.63,
    y: -11.17,
    rotate: -10.86
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 371.1,
    y: -32.47,
    rotate: -17.79
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 554.63,
    y: -93.64,
    rotate: -25.53
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 687.4,
    y: -156.8,
    rotate: -32.82
  }, "H")), /*#__PURE__*/React.createElement("circle", {
    cx: 8914.2,
    cy: 6782.7,
    r: 1093.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.93 .3677 -.3677 .93 9269.5 5700.6)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8913 .4534 -.4534 .8913 9382.8 5745.5)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "e"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8512 .5248 -.5248 .8512 9466.4 5787.4)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "a"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8183 .5748 -.5748 .8183 9545.7 5836.7)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "l"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.7605 .6493 -.6493 .7605 9583.3 5858.7)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.6708 .7416 -.7416 .6708 9714.8 5972.6)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.5876 .8092 -.8092 .5876 9794.2 6059.2)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.4977 .8674 -.8674 .4977 9867.8 6159.9)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "X"), /*#__PURE__*/React.createElement("circle", {
    cx: 8909.8,
    cy: 6784.8,
    r: 1103.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.229 -.9734 .9734 .229 7772.6 6610.9)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "190.96px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 173.11,
    y: 1.69,
    rotate: 6.77
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 268.68,
    y: 12.29,
    rotate: 11.94
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 376.22,
    y: 34.24,
    rotate: 17.71
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 492.1,
    y: 71.41,
    rotate: 23.07
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 581.27,
    y: 107.65,
    rotate: 28.89
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 702.15,
    y: 174,
    rotate: 35.52
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 805.49,
    y: 247.42,
    rotate: 41.63
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 892.69,
    y: 323.75,
    rotate: 47.72
  }, "A")), /*#__PURE__*/React.createElement("circle", {
    cx: 8908.3,
    cy: 6776.7,
    r: 1109.4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.5393 .8421 -.8421 .5393 7786.3 7384.8)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 178.79,
    y: -2.73,
    rotate: -5.01
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 203.36,
    y: -2.59,
    rotate: -8.44
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 330.05,
    y: -22.2,
    rotate: -11.86
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 364.25,
    y: -27.39,
    rotate: -15.5
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 487.44,
    y: -62.61,
    rotate: -19.14
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 526.22,
    y: -74.9,
    rotate: -22.34
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 638.3,
    y: -121.61,
    rotate: -27.7
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 741.57,
    y: -176.35,
    rotate: -32.96
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 835.13,
    y: -237.17,
    rotate: -38.11
  }, "S")), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 8924,
    x2: 8688.3,
    y1: 5710.7,
    y2: 5444.2
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(8613.4 6909.1)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "369.96px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 0,
    y: 0,
    letterSpacing: -4
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 350.35,
    y: 0,
    letterSpacing: -28
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 617.08,
    y: 0,
    letterSpacing: 12
  }, "C")), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 8970.9,
    y: 6880.3,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 9217.8,
    y: 6880.3,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 9489.6,
    y: 6880.3,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m7858.4 6959.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m8824.1 7833.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 8836.2,
    x2: 9112.1,
    y1: 7836.4,
    y2: 8111.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 7591.9,
    x2: 7842.1,
    y1: 7079.1,
    y2: 6820.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 9967.9,
    x2: 10235,
    y1: 6787.9,
    y2: 6541.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 8908.3,
    cy: 6776.7,
    r: 1350.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 8905.1,
    cy: 6773.5,
    r: 1062.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 5641.8,
    cy: 6776.8,
    r: 1350.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 5638.5,
    cy: 6773.6,
    r: 1062.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "5016.4 6681 5016.4 6751.5 5174.5 6663.8 5332.8 6751.5 5332.8 6681.6 5174.6 6592.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "5096 6726.6 5174.6 6683.7 5252 6726.6 5174.6 6772"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "5016.4 6770.3 5016.4 6862.4 5077.8 6829.6 5077.8 6735.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "5332.8 6770.3 5332.8 6863 5270.3 6828.7 5270.3 6735.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "5174.6 6863.9 5252 6820.3 5252 6726.6 5174.6 6772"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "5174.6 6886.1 5174.6 6955.5 5332.8 6863 5270.3 6828.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "5077.8 6829.6 5174.6 6886.1 5174.6 6955.5 5016.4 6862.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "5096 6726.6 5096 6819.4 5174.6 6863.9 5174.6 6772"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m5421.8 5444.3l235.72 266.54s351.25-9.52 691.35 272.01c375.68 310.98 352.61 790.75 352.61 790.75l267.45-232.08s-60.19-466.2-474.08-811.51c-416.85-347.81-876.14-312.41-1073-285.71z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5647.7,
    cy: 6782.8,
    r: 1093.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.845 -.5348 .5348 .845 6257.5 7884.6)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 146.54,
    y: -1,
    rotate: -5.79
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 250.63,
    y: -11.17,
    rotate: -10.86
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 371.1,
    y: -32.47,
    rotate: -17.79
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 554.63,
    y: -93.64,
    rotate: -25.53
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 687.4,
    y: -156.8,
    rotate: -32.82
  }, "H")), /*#__PURE__*/React.createElement("circle", {
    cx: 5647.7,
    cy: 6782.8,
    r: 1093.7,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.93 .3677 -.3677 .93 6003 5700.7)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8913 .4534 -.4534 .8913 6116.2 5745.6)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "e"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8512 .5248 -.5248 .8512 6199.9 5787.5)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "a"), /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "matrix(.8183 .5748 -.5748 .8183 6279.2 5836.8)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "l"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.7605 .6493 -.6493 .7605 6316.8 5858.8)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "M"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.6708 .7416 -.7416 .6708 6448.3 5972.7)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "T"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.5876 .8091 -.8091 .5876 6527.7 6059.3)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "matrix(.4977 .8674 -.8674 .4977 6601.2 6160)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, "X"), /*#__PURE__*/React.createElement("circle", {
    cx: 5643.3,
    cy: 6784.9,
    r: 1103.6,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.229 -.9734 .9734 .229 4506.1 6611)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "190.96px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 173.11,
    y: 1.69,
    rotate: 6.77
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 268.68,
    y: 12.29,
    rotate: 11.94
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 376.22,
    y: 34.24,
    rotate: 17.71
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 492.1,
    y: 71.41,
    rotate: 23.07
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 581.27,
    y: 107.65,
    rotate: 28.89
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 702.15,
    y: 174,
    rotate: 35.52
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 805.49,
    y: 247.41,
    rotate: 41.62
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 892.69,
    y: 323.75,
    rotate: 47.72
  }, "A")), /*#__PURE__*/React.createElement("circle", {
    cx: 5641.8,
    cy: 6776.8,
    r: 1109.4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.5393 .8421 -.8421 .5393 4519.8 7384.9)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "191.97px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 178.79,
    y: -2.73,
    rotate: -5.01
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 203.36,
    y: -2.59,
    rotate: -8.44
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 330.05,
    y: -22.2,
    rotate: -11.86
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 364.25,
    y: -27.39,
    rotate: -15.5
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 487.44,
    y: -62.61,
    rotate: -19.14
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 526.22,
    y: -74.9,
    rotate: -22.34
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 638.3,
    y: -121.61,
    rotate: -27.7
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 741.57,
    y: -176.35,
    rotate: -32.96
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 835.13,
    y: -237.17,
    rotate: -38.11
  }, "S")), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 5657.5,
    x2: 5421.8,
    y1: 5710.8,
    y2: 5444.3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(5346.9 6909.2)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "369.96px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 0,
    y: 0,
    letterSpacing: -4
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 350.35,
    y: 0,
    letterSpacing: -28
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 617.08,
    y: 0,
    letterSpacing: 12
  }, "C")), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 5704.4,
    y: 6880.3,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 5951.3,
    y: 6880.3,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 6223.1,
    y: 6880.3,
    width: 28.88,
    height: 28.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m4591.9 6959.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m5557.5 7833.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 5569.7,
    x2: 5845.6,
    y1: 7836.5,
    y2: 8111.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 4325.4,
    x2: 4575.6,
    y1: 7079.2,
    y2: 6820.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 6701.4,
    x2: 6968.9,
    y1: 6788,
    y2: 6541.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 5641.8,
    cy: 6776.8,
    r: 1350.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 5638.5,
    cy: 6773.6,
    r: 1062.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: -1256.3,
    cy: -3097.5,
    r: 741
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: -1258.1,
    cy: -3099.3,
    r: 583.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-1599.5 -3150.1 -1599.5 -3111.4 -1512.7 -3159.5 -1425.8 -3111.4 -1425.8 -3149.8 -1512.7 -3198.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "-1555.8 -3125.1 -1512.7 -3148.6 -1470.2 -3125.1 -1512.7 -3100.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-1599.5 -3101.1 -1599.5 -3050.6 -1565.8 -3068.5 -1565.8 -3120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-1425.8 -3101.1 -1425.8 -3050.2 -1460.1 -3069 -1460.1 -3120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-1512.7 -3049.8 -1470.2 -3073.6 -1470.2 -3125.1 -1512.7 -3100.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-1512.7 -3037.6 -1512.7 -2999.5 -1425.8 -3050.2 -1460.1 -3069"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "-1565.8 -3068.5 -1512.7 -3037.6 -1512.7 -2999.5 -1599.5 -3050.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "-1555.8 -3125.1 -1555.8 -3074.1 -1512.7 -3049.8 -1512.7 -3100.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m-1377-3828.7l129.35 146.26s-344.02 0-495.37 259.01c-130.27 222.93-98.31 349.82-98.31 349.82l-137.3 142.07s-74.28-243.3 59.32-497.18c187.35-356.02 542.31-399.98 542.31-399.98z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -1253,
    cy: -3094.3,
    r: 600.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.845 -.5348 .5348 .845 -918.41 -2489.6)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 80.43,
    y: -0.55,
    rotate: -5.79
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 137.53,
    y: -6.13,
    rotate: -10.86
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 203.64,
    y: -17.82,
    rotate: -17.79
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 304.35,
    y: -51.38,
    rotate: -25.53
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 377.21,
    y: -86.04,
    rotate: -32.82
  }, "H")), /*#__PURE__*/React.createElement("circle", {
    cx: -1253,
    cy: -3094.3,
    r: 600.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.93 .3677 -.3677 .93 -1058.1 -3688)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 66.84,
    y: 0.03,
    rotate: 5.39
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 117.97,
    y: 4.56,
    rotate: 10.08
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 168.41,
    y: 13.73,
    rotate: 13.52
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 192.03,
    y: 17.37,
    rotate: 18.92
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 282.12,
    y: 48.93,
    rotate: 26.3
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 340.09,
    y: 77.13,
    rotate: 32.44
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 397.96,
    y: 113.68,
    rotate: 38.58
  }, "X")), /*#__PURE__*/React.createElement("circle", {
    cx: -1255.4,
    cy: -3093.1,
    r: 605.58,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.229 -.9734 .9734 .229 -1879.5 -3188.5)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "104.79px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 94.96,
    y: 0.93,
    rotate: 6.77
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 147.39,
    y: 6.74,
    rotate: 11.94
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 206.42,
    y: 18.78,
    rotate: 17.71
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 270.01,
    y: 39.17,
    rotate: 23.07
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 318.91,
    y: 59.05,
    rotate: 28.89
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 385.23,
    y: 95.44,
    rotate: 35.52
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 441.95,
    y: 135.72,
    rotate: 41.62
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 489.79,
    y: 177.59,
    rotate: 47.71
  }, "A")), /*#__PURE__*/React.createElement("circle", {
    cx: -1256.3,
    cy: -3097.5,
    r: 608.77,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.5393 .8421 -.8421 .5393 -1872 -2763.8)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 98.13,
    y: -1.5,
    rotate: -5.02
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 111.59,
    y: -1.42,
    rotate: -8.44
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 181.11,
    y: -12.18,
    rotate: -11.86
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 199.88,
    y: -15.03,
    rotate: -15.5
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 267.48,
    y: -34.35,
    rotate: -19.14
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 288.76,
    y: -41.1,
    rotate: -22.34
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 350.27,
    y: -66.73,
    rotate: -27.7
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 406.93,
    y: -96.77,
    rotate: -32.96
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 458.29,
    y: -130.16,
    rotate: -38.11
  }, "S")), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: -1247.7,
    x2: -1377,
    y1: -3682.5,
    y2: -3828.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(-1418.1 -3024.9)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "203.01px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 0,
    y: 0,
    letterSpacing: -2
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 192.25,
    y: 0,
    letterSpacing: -15
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 338.62,
    y: 0,
    letterSpacing: 6
  }, "C")), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: -1221.9,
    y: -3040.7,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: -1086.4,
    y: -3040.7,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: -937.28,
    y: -3040.7,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m-1832.4-2997.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m-1302.5-2517.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: -1295.8,
    x2: -1144.5,
    y1: -2516,
    y2: -2364.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: -1978.6,
    x2: -1841.3,
    y1: -2931.6,
    y2: -3073.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: -674.84,
    x2: -528.03,
    y1: -3091.4,
    y2: -3226.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: -1256.3,
    cy: -3097.5,
    r: 741
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: -1258.1,
    cy: -3099.3,
    r: 583.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 2328.1,
    cy: -3097.4,
    r: 741
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 2326.3,
    cy: -3099.1,
    r: 583.32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "1985 -3150 1985 -3111.3 2071.6 -3159.4 2158.4 -3111.3 2158.4 -3149.7 2071.7 -3198.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "2028.6 -3125 2071.7 -3148.5 2114.2 -3125 2071.7 -3100.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1985 -3100.9 1985 -3050.7 2018.4 -3068.6 2018.4 -3119.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "2158.4 -3100.8 2158.4 -3050.4 2124.3 -3069 2124.3 -3119.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "2071.7 -3049.8 2113.9 -3073.6 2113.9 -3124.8 2071.7 -3100"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "2071.7 -3037.4 2071.7 -2999.4 2158.5 -3050.1 2124.2 -3068.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2018.6 -3068.4 2071.7 -3037.4 2071.7 -2999.4 1984.8 -3050.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "2028.3 -3125.2 2028.3 -3074 2071.7 -3049.4 2071.7 -3100.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2662.8-2577.1c11.04-6.99 26.94-10.82 31.95-2.9l4.9 7.74-8.19 5.18-2.93-4.63c-3.32-5.25-13.24-2.59-20.62 2.08-14.69 9.3-17.63 25.12-8.51 39.54 9.18 14.51 25.38 19.22 40.15 9.87 5.61-3.55 15.75-12.34 11.86-18.48l-5.24-8.28-12.28 7.78-4.4-6.94 20.47-12.96 11.16 17.62c6.14 9.7-7.86 23.43-17.3 29.4-19.32 12.23-41.75 6.73-53.52-11.88-11.75-18.59-7.08-40.75 12.5-53.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2724.2-2595.1c11.93-9.36 25.04-5.46 33.56 5.4 0.85 1.08 2.16 3.26 2.16 3.26l-30.66 24.06c7.78 8.89 18.23 8.73 25.69 2.87 7.29-5.72 8.81-14.54 8.81-14.54l7.93 3.28s-1.75 10.74-11.77 18.61c-13.18 10.34-29.69 7.9-39.44-4.53-10.48-13.34-8.21-29.05 3.72-38.41zm23.65 9.83c-6.04-7.18-13.5-7.48-18.81-3.32-6.13 4.81-7.85 12.86-3.49 20.81l22.3-17.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2765.5-2630.6c11.6-10.89 28.97-11.16 40 0.59 11.1 11.83 9.81 29.22-1.78 40.11-11.6 10.89-29.04 11.08-40.15-0.74-11.03-11.75-9.67-29.07 1.93-39.96zm32.16 34.25c7.3-6.85 7.88-18.38 0.24-26.52-7.57-8.06-19.05-8.13-26.34-1.28-7.37 6.92-7.95 18.31-0.38 26.37 7.63 8.14 19.1 8.35 26.48 1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m2823.8-2620.9l5.96-7.1-41.43-40.93-6.09 7.26-6.22-5.21 13.54-16.14 46.96 14.5c3.09 1.08 5.2 2.16 5.2 2.16l0.14-0.16s-1.44-1.89-3.03-4.74l-22.45-43.72 13.54-16.14 6.22 5.21-6.09 7.26 47.52 33.67 5.96-7.1 6.3 5.28-18.41 21.95-6.3-5.28 5.75-6.86-36.23-25.99c-1.84-1.41-4.48-4.17-4.48-4.17l-0.2 0.24s2.2 2.95 3.28 4.95l18.98 38.19-5.96 7.1-40.91-12.04c-2.16-0.71-5.44-2.37-5.44-2.37l-0.2 0.24s3.18 2.11 4.88 3.68l31.89 31.15 5.75-6.86 6.3 5.28-18.41 21.95-6.32-5.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m2888.4-2700l3.82-6.06-43.3-55.35 6.35-10.07 68.59 15.26 3.82-6.06 6.95 4.38-13.77 21.83-6.95-4.38 4.22-6.68-17.08-3.93-14.05 22.27 10.89 13.72 4.27-6.77 6.95 4.38-13.77 21.83-6.94-4.37zm4.13-53.32l-26.66-6.11c-3.15-0.74-5.48-1.97-5.48-1.97l-0.17 0.27s2.06 1.67 4.14 4.1l16.94 21.52 11.23-17.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "m2932.8-2771.3l3.91-8.4-52.62-24.5-3.91 8.4-7.35-3.42 12.32-26.45 7.35 3.42-3.96 8.5 22.44 10.45 16.27-34.95-22.44-10.45-3.96 8.5-7.35-3.42 12.32-26.45 7.35 3.42-3.91 8.4 52.62 24.5 3.91-8.4 7.45 3.47-12.31 26.45-7.45-3.47 3.96-8.5-22.35-10.4-16.27 34.95 22.35 10.4 3.96-8.5 7.45 3.47-12.31 26.45-7.47-3.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2534.5-3693.5l8.62 3.41 21.34-53.98-8.62-3.41 2.98-7.54 29.98 11.85c4.9 1.94 8.84 3.72 12.15 6.5 6.28 5.31 8.68 13.29 4.96 22.69-3.95 9.99-12.26 14.97-21.97 13.74l-0.08 0.2s1.38 1.68 1.66 4.39l3.06 20.92c0.34 2.29 1.46 3.18 3.91 4.15l2.06 0.81-3.02 7.64-5.88-2.32c-5.88-2.32-6.82-3.94-7.55-8.99l-3.2-23.13c-0.6-3.64-1.53-5.02-5.74-6.69l-8.23-3.25-8.02 20.28 8.52 3.37-3.02 7.64-26.94-10.65 3.03-7.63zm43.51-15.53c7.54 2.98 14.48 0.06 17.69-8.07 2.13-5.39 1.45-9.96-2.17-13.43-1.9-1.77-4.69-3.33-8.02-4.64l-11.46-4.53-9.95 25.18 13.91 5.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2639.6-3698.5c13.53 6.85 15.54 20.39 9.3 32.7-0.62 1.22-2.04 3.33-2.04 3.33l-34.77-17.61c-4.77 10.81-0.2 20.21 8.26 24.49 8.27 4.19 16.9 1.83 16.9 1.83l0.38 8.58s-10.47 2.96-21.85-2.8c-14.94-7.57-19.71-23.56-12.58-37.66 7.68-15.13 22.87-19.71 36.4-12.86zm1.1 25.59c3.95-8.51 1.07-15.4-4.95-18.45-6.96-3.52-14.97-1.68-20.33 5.64l25.28 12.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2679.8-3650.7l2.87 1.76 1.05-1.71c4.41-7.18 1.82-12.23-3.74-15.65-7.18-4.41-15.72-3.59-15.72-3.59l0.3-8.34s9.95-1.31 20.54 5.2c11.58 7.11 13.99 16.87 6.94 28.36l-12.46 20.29c-0.83 1.35-0.49 2.42 0.76 3.19l4.58 2.81-4.13 6.73-9.07-5.57c-4.04-2.48-4.44-5.45-2.62-8.41l0.39-0.63c1.1-1.8 2.18-2.74 2.18-2.74l-0.18-0.11s-9.85 7.18-20.89 0.4c-7.54-4.63-12.38-13.66-6.65-23 8.76-14.26 28.31-3.61 35.85 1.01zm-23.19 16.43c7.72 4.74 17.33-0.24 21.52-7.06l1.16-1.88-2.24-1.38c-4.13-2.54-18.51-11.12-23.86-2.41-2.49 4.03-1.78 9.53 3.42 12.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m2721.7-3663.6l-7.26-5.07 4.52-6.48 15.63 10.91-33.53 48.02c-2.59 3.71-3.48 6.82 0.32 9.48 1.38 0.97 2.39 1.54 2.39 1.54l-4.91 6.85s-1.85-1.03-3.83-2.42c-6.22-4.34-9.82-10.59-2.71-20.78l29.38-42.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m2705.4-3605.9l7.07 6 41.18-41.18-7.23-6.14 5.25-6.18 16.06 13.64-14.78 46.87c-1.09 3.08-2.19 5.19-2.19 5.19l0.16 0.14s1.9-1.43 4.76-3l43.85-22.19 16.06 13.64-5.25 6.18-7.23-6.14-33.95 47.32 7.07 6-5.32 6.26-21.84-18.54 5.32-6.26 6.83 5.79 26.2-36.07c1.42-1.83 4.19-4.45 4.19-4.45l-0.24-0.2s-2.96 2.18-4.97 3.25l-38.3 18.75-7.07-6 12.28-40.84c0.72-2.15 2.4-5.43 2.4-5.43l-0.24-0.2s-2.13 3.16-3.71 4.86l-31.34 31.71 6.83 5.8-5.32 6.26-21.84-18.54 5.31-6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m2789.1-3530.5l6.31 6.93 42.55-38.71-11.77-12.94-8.57 7.8-6.17-6.78 14.96-13.61 42.96 47.22-14.96 13.61-6.17-6.78 8.57-7.8-11.77-12.94-42.55 38.71 6.31 6.94-6.08 5.53-19.71-21.66 6.09-5.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m2822.9-3492.9l5.47 7.49 46.87-34.24-5.47-7.48 6.55-4.79 19.02 26.03c3.11 4.25 5.49 7.86 6.8 11.99 2.47 7.85 0.24 15.87-7.92 21.83-8.68 6.34-18.36 6.11-25.91-0.11l-0.17 0.12s0.27 2.15-0.94 4.6l-8.59 19.32c-0.93 2.12-0.46 3.47 1.09 5.6l1.3 1.79-6.63 4.85-3.73-5.1c-3.73-5.1-3.66-6.98-1.58-11.63l9.64-21.27c1.43-3.4 1.39-5.06-1.28-8.72l-5.22-7.15-17.61 12.86 5.41 7.4-6.63 4.85-17.09-23.39 6.62-4.85zm45.09 10.11c4.78 6.55 12.21 7.78 19.27 2.62 4.68-3.42 6.54-7.65 5.34-12.51-0.66-2.52-2.19-5.32-4.3-8.21l-7.27-9.95-21.86 15.97 8.82 12.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "m2862.2-3438.8l3.48 6.02 35.04 1.9 15.38-30.66-3.42-5.93 7.02-4.06 12.96 22.44-7.02 4.06-3.95-6.84-10.71 20.42c-0.79 1.79-1.61 3.12-1.61 3.12l0.11 0.18s1.5-0.14 3.45 0.08l22.83 0.56-3.85-6.66 7.02-4.06 12.59 21.8-7.02 4.06-3.48-6.02-35.27-1.89-15.15 30.65 3.53 6.11-7.11 4.11-12.96-22.44 7.12-4.11 3.9 6.75 10.57-20.46c0.88-1.85 1.7-3.17 1.7-3.17l-0.1-0.18c-0.05-0.09-1.5 0.14-3.49 0.07l-22.79-0.7 3.9 6.75-7.12 4.11-12.64-21.89 7.09-4.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1697.8-3194.2l2.11-8.98-55.12-17.81-2.16 9.18-7.85-1.85 4.8-20.4 48.2-8.14c3.22-0.43 5.59-0.41 5.59-0.41l0.05-0.2s-2.12-1.04-4.82-2.86l-39.52-28.78 4.8-20.4 7.85 1.85-2.16 9.18 57.28 8.63 2.11-8.98 7.96 1.87-6.53 27.74-7.96-1.87 2.04-8.67-43.81-6.86c-2.27-0.43-5.84-1.7-5.84-1.7l-0.07 0.31s3.28 1.63 5.12 2.93l33.96 25.43-2.11 8.98-41.73 7.62c-2.23 0.34-5.89 0.34-5.89 0.34l-0.07 0.31s3.77 0.46 5.99 1.09l42.28 13.39 2.04-8.67 7.96 1.87-6.53 27.74-7.97-1.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1708.6-3324.1l1.15-3.15-1.87-0.68c-7.88-2.87-12.28 0.66-14.51 6.76-2.87 7.88-0.38 16.03-0.38 16.03l-8.19 1.37s-3.25-9.44 0.98-21.06c4.63-12.7 13.66-16.99 26.26-12.41l22.25 8.1c1.48 0.54 2.45 0 2.95-1.38l1.83-5.02 7.38 2.69-3.62 9.95c-1.61 4.43-4.43 5.41-7.67 4.23l-0.69-0.25c-1.97-0.72-3.11-1.58-3.11-1.58l-0.07 0.2s8.96 8.17 4.55 20.28c-3.01 8.27-10.85 14.78-21.09 11.06-15.64-5.7-9.16-26.87-6.15-35.14zm20.62 19.33c3.08-8.47-3.68-16.84-11.16-19.57l-2.07-0.75-0.9 2.46c-1.65 4.53-7.15 20.26 2.4 23.74 4.43 1.61 9.65-0.17 11.73-5.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1768.9-3349.3c3.92-8.34 3.34-16.96-6.52-21.59l-3.79-1.78c-1.52-0.71-2.9-1.71-2.9-1.71l-0.09 0.19c3.41 5.07 4.3 11.05 1 18.07-6.24 13.28-20.79 16.39-34.64 9.88-13.75-6.46-20.38-18.96-14.09-32.33 2.94-6.26 8.43-11.78 15.18-11.85l0.09-0.19s-0.75-0.12-1.99-0.7c-3.03-1.43-4.12-3.79-2.25-7.77l4.82-10.24 7.11 3.34-2.5 5.31c-0.58 1.23-0.32 2.4 0.92 2.98l36.98 17.39c15.84 7.44 16.24 22.34 10.54 34.48-2.72 5.79-7.1 10.91-11.7 14.53l-5.59-6.33c0-0.01 6.03-4.47 9.42-11.68zm-29.95-32.84c-12.52-5.89-18.98-1.51-22.5 5.98-3.88 8.25-0.04 15.85 9.73 20.44 9.96 4.68 19.24 2.67 23.29-5.96 3.13-6.63 2-14.57-10.52-20.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1766.3-3393.4l4.26-7.1-30.01-18c-1.35-0.81-2.41-0.47-3.16 0.79l-3.34 5.57-6.74-4.04 6.14-10.24c2.37-3.95 5.16-4.73 8.48-2.73l2.34 1.4c1.44 0.86 2.44 1.83 2.44 1.83l0.11-0.18c-1.89-2.35-7.33-12.83-0.44-24.33 6.25-10.43 14.9-11.59 26.49-4.64l22.38 13.42 4.31-7.19 6.74 4.04-9.54 15.91-27.14-16.28c-6.38-3.83-12.17-5.59-16.53 1.69-5.5 9.17-0.75 20.2 8.33 25.64l14.38 8.62 4.31-7.19 6.74 4.04-13.8 23.01-6.75-4.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1798.9-3489.3l1.98-2.7-1.6-1.18c-6.76-4.96-11.97-2.82-15.82 2.42-4.96 6.76-4.86 15.28-4.86 15.28l-8.25-0.99s-0.48-9.97 6.85-19.94c8-10.89 17.88-12.48 28.69-4.54l19.08 14.02c1.27 0.93 2.35 0.69 3.22-0.49l3.16-4.31 6.33 4.65-6.27 8.53c-2.79 3.8-5.77 3.95-8.55 1.91l-0.59-0.43c-1.69-1.24-2.54-2.39-2.54-2.39l-0.12 0.17s6.31 10.36-1.33 20.74c-5.21 7.09-14.56 11.15-23.34 4.69-13.42-9.85-1.25-28.35 3.96-35.44zm14.36 24.34c5.34-7.26 1.19-17.2-5.22-21.91l-1.77-1.3-1.55 2.11c-2.85 3.88-12.55 17.43-4.36 23.45 3.8 2.79 9.31 2.54 12.9-2.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m1833.1-3495l6.19-6.84-42.82-38.73-6.19 6.84-5.98-5.41 21.16-23.39c4.15-4.58 7.47-7.79 11.87-10.46 12.75-7.54 28.42-5.8 41.79 6.29 13.29 12.02 16.56 26.99 10.28 40.81-2.07 4.63-5.06 8.56-9 12.92l-21.23 23.47-6.07-5.5zm20.49-23.28c3.23-3.57 5.59-6.81 7.04-10.59 4.11-9.7 1.19-20.69-8.84-29.75-10.1-9.14-21.32-10.95-30.57-6.04-3.83 2.05-6.52 4.7-9.75 8.28l-7.59 8.39 42.12 38.1 7.59-8.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m1880.4-3547.4l5.35-4.71-25.82-64.96 8.88-7.83 61.2 33.79 5.35-4.71 5.4 6.13-19.26 16.97-5.4-6.13 5.9-5.2-15.2-8.53-19.66 17.32 6.55 16.15 5.98-5.27 5.4 6.13-19.26 16.97-5.41-6.12zm18.88-49.74l-23.73-13.3c-2.8-1.59-4.68-3.41-4.68-3.41l-0.24 0.21s1.5 2.17 2.8 5.08l10.13 25.29 15.72-13.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m1944.5-3601.8l7.57-5.45-33.44-46.43-14.12 10.17 6.74 9.35-7.4 5.33-11.76-16.33 51.53-37.11 11.76 16.33-7.4 5.33-6.74-9.35-14.12 10.17 33.44 46.43 7.57-5.45 4.78 6.63-23.64 17.03-4.77-6.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "m1976.7-3625.6l6.16-3.58-12.67-68.75 10.24-5.95 53.44 45.06 6.16-3.58 4.11 7.07-22.2 12.9-4.11-7.07 6.8-3.95-13.25-11.33-22.65 13.16 3.28 17.12 6.89-4 4.11 7.07-22.2 12.9-4.11-7.07zm28.21-45.1l-20.69-17.67c-2.43-2.1-3.93-4.26-3.93-4.26l-0.27 0.16s1.04 2.42 1.76 5.53l5.01 26.78 18.12-10.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1721.5-2764.8l5 7.81 51.44-27.31-5.11-7.98 6.83-4.37 11.36 17.74-27.86 40.49c-1.95 2.62-3.62 4.32-3.62 4.32l0.11 0.18s2.24-0.81 5.43-1.48l48.43-8.37 11.36 17.74-6.83 4.37-5.11-7.98-46.32 35.29 5 7.81-6.92 4.43-15.45-24.13 6.92-4.43 4.83 7.54 35.62-26.81c1.89-1.34 5.32-3.03 5.32-3.03l-0.17-0.27s-3.47 1.22-5.7 1.65l-42.12 6.7-5-7.81 23.71-35.45c1.32-1.85 3.88-4.49 3.88-4.49l-0.17-0.27s-2.97 2.4-4.98 3.56l-39.26 21.14 4.83 7.54-6.92 4.43-15.45-24.13 6.92-4.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1780.2-2682.4l6.69 8.67-8.76 6.76-6.69-8.67 8.76-6.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1830.8-2706.2l-6.14-7.09 6.13-5.31 19.17 22.14-6.13 5.31-6.14-7.09-29.07 25.17c-3.66 3.17-6.23 6.65-7.3 10.08-1.66 5.48 0.06 11.65 4.75 17.07 4.62 5.34 10.55 8 16.37 7 3.48-0.65 7.28-2.54 10.94-5.71l28.99-25.1-6.14-7.09 6.13-5.31 19.1 22.06-6.13 5.31-6.07-7.01-29.15 25.24c-5.34 4.62-11.44 7.39-17.08 7.96-8.72 0.87-17.44-3.57-24.06-11.22-6.89-7.96-9.66-17.27-7.79-25.58 1.31-5.73 5.04-10.91 10.46-15.6l29.16-25.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1830.6-2623.2l7.62 7.87-7.94 7.7-7.62-7.87 7.94-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1911.3-2634.8c6.61 6.04 18.73 21.52 10.99 30l-6.11 6.69-7.24-6.6 3.91-4.28c4.4-4.82-2.29-14.21-7.35-18.83-11.75-10.72-28.27-9.97-39.63 2.48-11.86 12.99-11.44 30.35 0.54 41.28 3.89 3.55 14.97 11.1 19.59 6.04l3.91-4.28 7.24 6.6-6.11 6.69c-7.39 8.09-23.64-1.76-31.27-8.72-16.49-15.06-16.82-38.6-2.19-54.63 14.69-16.1 37.84-16.93 53.72-2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "m1893.8-2564.7l8.54 6.86-6.92 8.63-8.54-6.86 6.92-8.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m1923.1-2556l-3.18 4.46c-3.18 4.46 0.66 11.22 7 15.75 6.94 4.96 14.33 5.32 18.61-0.68 5.02-7.03-0.44-14.43-5.81-22.67-5.83-8.7-11.52-17.94-3.87-28.66 8.14-11.4 20.81-9.73 31.01-2.45 9.09 6.49 15.89 16.53 11.18 23.13l-5.08 7.11-7.97-5.7 3-4.2c2.51-3.51-1.54-9.26-6.51-12.81-5.91-4.23-12.59-4.85-16.57 0.72-4.59 6.43-0.04 12.92 4.9 20.33 6.53 9.71 12.91 19.45 4.88 30.68-8.27 11.57-21.98 10.84-33.21 2.81-9.43-6.74-16.97-18.47-10.79-27.13l4.53-6.34 7.88 5.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m1998.4-2519.1l2.91 1.69 1.01-1.73c4.24-7.28 1.53-12.27-4.11-15.55-7.28-4.24-15.8-3.22-15.8-3.22l0.1-8.35s9.92-1.54 20.66 4.71c11.75 6.83 14.39 16.54 7.61 28.19l-11.97 20.58c-0.79 1.37-0.44 2.43 0.84 3.17l4.64 2.7-3.97 6.83-9.2-5.35c-4.1-2.38-4.57-5.34-2.82-8.35l0.37-0.64c1.06-1.82 2.11-2.79 2.11-2.79l-0.18-0.11s-9.67 7.41-20.87 0.9c-7.65-4.45-12.7-13.36-7.19-22.83 8.42-14.48 28.21-4.3 35.86 0.15zm-22.79 16.96c7.83 4.56 17.32-0.65 21.34-7.57l1.11-1.91-2.28-1.32c-4.19-2.44-18.77-10.68-23.91-1.85-2.37 4.1-1.54 9.58 3.74 12.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m2052.8-2491.3l3.06 1.42 0.84-1.81c3.55-7.64 0.4-12.36-5.52-15.11-7.64-3.55-16.03-1.76-16.03-1.76l-0.66-8.32s9.73-2.45 21 2.79c12.32 5.73 15.84 15.15 10.16 27.37l-10.03 21.59c-0.67 1.43-0.21 2.46 1.12 3.08l4.87 2.26-3.33 7.16-9.65-4.48c-4.3-2-5.04-4.9-3.58-8.05l0.31-0.67c0.89-1.91 1.85-2.98 1.85-2.98l-0.19-0.09s-8.95 8.27-20.7 2.81c-8.02-3.73-13.87-12.14-9.26-22.07 7.07-15.18 27.72-6.87 35.74-3.14zm-21.13 18.99c8.22 3.82 17.19-2.24 20.56-9.5l0.93-2.01-2.39-1.11c-4.39-2.04-19.67-8.91-23.98 0.35-1.99 4.31-0.66 9.69 4.88 12.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "m2085.2-2466.3l-1.85 5.15c-1.85 5.15 3.68 10.62 11.02 13.26 8.03 2.89 15.23 1.23 17.73-5.71 2.92-8.13-4.34-13.76-11.75-20.24-7.97-6.79-15.96-14.14-11.5-26.53 4.74-13.18 17.38-15.02 29.18-10.77 10.51 3.78 19.78 11.6 17.04 19.23l-2.96 8.23-9.22-3.32 1.75-4.86c1.46-4.06-4-8.49-9.75-10.56-6.84-2.46-13.43-1.25-15.75 5.19-2.67 7.43 3.47 12.44 10.23 18.24 8.92 7.57 17.7 15.21 13.03 28.2-4.81 13.38-18.21 16.4-31.2 11.73-10.9-3.92-21.35-13.17-17.75-23.18l2.64-7.34 9.11 3.28z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 2336.7,
    x2: 2207.4,
    y1: -3682.4,
    y2: -3828.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m2174-3040.6h17.86l9.14-111.86h-18.27v-15.63h40.6l36.74 87.29c2.23 5.89 3.25 10.35 3.25 10.35h0.41s1.01-4.47 3.25-10.35l36.74-87.29h40.6v15.63h-18.27l9.14 111.86h17.86v15.83h-55.22v-15.83h17.26l-6.5-85.67c-0.2-4.47 0.61-11.77 0.61-11.77h-0.61s-1.62 6.9-3.25 10.96l-32.89 75.32h-17.86l-32.89-75.32c-1.62-4.06-3.25-10.96-3.25-10.96h-0.61s0.81 7.31 0.61 11.77l-6.5 85.67h17.26v15.83h-55.22v-15.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m2382.9-3152.4h-18.07v-15.63h56.44v15.63h-18.07v74.1c0 9.34 1.83 17.46 5.48 23.35 5.89 9.34 17.05 14.62 30.86 14.62 13.6 0 24.97-5.28 30.86-15.02 3.45-5.89 5.48-13.8 5.48-23.14v-73.9h-18.07v-15.63h56.23v15.63h-17.86v74.3c0 13.6-3.65 25.99-9.95 34.92-9.74 13.8-27.2 20.91-46.69 20.91-20.3 0-37.35-7.71-47.1-20.91-6.7-9.14-9.54-21.11-9.54-34.92v-74.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m2587.1-3170.5c17.26 0 54.61 6.29 54.61 28.42v17.46h-18.88v-11.17c0-12.59-21.72-17.26-34.92-17.26-30.65 0-53.19 22.53-53.19 55.01 0 33.9 23.14 58.06 54.41 58.06 10.15 0 35.73-3.65 35.73-16.85v-11.16h18.88v17.46c0 21.11-35.93 28.22-55.83 28.22-43.04 0-74.1-33.09-74.1-74.91 0.01-42.02 31.88-73.28 73.29-73.28z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 2362.5,
    y: -3040.9,
    width: 15.91,
    height: 15.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 2498,
    y: -3040.9,
    width: 15.91,
    height: 15.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 2647.3,
    y: -3040.9,
    width: 15.91,
    height: 15.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m1752-2997"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m2281.8-2517.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 2288.5,
    x2: 2439.9,
    y1: -2515.9,
    y2: -2364.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 1605.7,
    x2: 1743,
    y1: -2931.5,
    y2: -3073.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 2909.5,
    x2: 3056.3,
    y1: -3091.3,
    y2: -3226.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 2328.2,
    cy: -3097.2,
    r: 741.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 2326.3,
    cy: -3099.1,
    r: 583.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 535.99,
    cy: -3097.5,
    r: 741
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 534.22,
    cy: -3099.2,
    r: 583.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "192.8 -3150 192.8 -3111.3 279.58 -3159.4 366.44 -3111.3 366.44 -3149.7 279.62 -3198.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "236.51 -3125 279.62 -3148.6 322.1 -3125 279.62 -3100.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "192.8 -3101 192.8 -3050.5 226.51 -3068.5 226.51 -3119.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "366.44 -3101 366.44 -3050.2 332.16 -3069 332.16 -3119.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "279.62 -3049.7 322.1 -3073.6 322.1 -3125 279.62 -3100.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "279.62 -3037.5 279.62 -2999.4 366.44 -3050.2 332.16 -3069"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "226.51 -3068.5 279.62 -3037.5 279.62 -2999.4 192.8 -3050.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "236.51 -3125 236.51 -3074.1 279.62 -3049.7 279.62 -3100.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m496.44-2516l151.39 151.11s318.78-42.44 506.7-324.44c174.03-261.16 109.73-537.31 109.73-537.31l-146.82 135.27s23.38 197.67-156.81 390.06c-199.11 212.59-464.19 185.31-464.19 185.31z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 539.26,
    cy: -3094.2,
    r: 600.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.845 -.5348 .5348 .845 873.88 -2489.6)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 80.43,
    y: -0.55,
    rotate: -5.79
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 137.53,
    y: -6.13,
    rotate: -10.86
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 203.64,
    y: -17.82,
    rotate: -17.79
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 304.35,
    y: -51.38,
    rotate: -25.53
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 377.21,
    y: -86.04,
    rotate: -32.82
  }, "H")), /*#__PURE__*/React.createElement("circle", {
    cx: 539.26,
    cy: -3094.2,
    r: 600.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.93 .3677 -.3677 .93 734.21 -3688)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 66.84,
    y: 0.03,
    rotate: 5.39
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 117.97,
    y: 4.56,
    rotate: 10.08
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 168.41,
    y: 13.73,
    rotate: 13.52
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 192.03,
    y: 17.37,
    rotate: 18.92
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 282.12,
    y: 48.93,
    rotate: 26.3
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 340.09,
    y: 77.13,
    rotate: 32.44
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 397.96,
    y: 113.68,
    rotate: 38.58
  }, "X")), /*#__PURE__*/React.createElement("circle", {
    cx: 536.84,
    cy: -3093,
    r: 605.58,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.229 -.9734 .9734 .229 -87.208 -3188.4)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "104.79px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 94.96,
    y: 0.93,
    rotate: 6.77
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 147.39,
    y: 6.74,
    rotate: 11.94
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 206.42,
    y: 18.78,
    rotate: 17.71
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 270.01,
    y: 39.17,
    rotate: 23.07
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 318.91,
    y: 59.05,
    rotate: 28.89
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 385.23,
    y: 95.44,
    rotate: 35.52
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 441.95,
    y: 135.72,
    rotate: 41.62
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 489.79,
    y: 177.59,
    rotate: 47.71
  }, "A")), /*#__PURE__*/React.createElement("circle", {
    cx: 535.99,
    cy: -3097.5,
    r: 608.77,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.5393 .8421 -.8421 .5393 -79.674 -2763.8)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 98.12,
    y: -1.5,
    rotate: -5.02
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 111.59,
    y: -1.42,
    rotate: -8.44
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 181.11,
    y: -12.18,
    rotate: -11.86
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 199.88,
    y: -15.03,
    rotate: -15.5
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 267.48,
    y: -34.35,
    rotate: -19.14
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 288.76,
    y: -41.1,
    rotate: -22.34
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 350.27,
    y: -66.73,
    rotate: -27.7
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 406.93,
    y: -96.77,
    rotate: -32.96
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 458.29,
    y: -130.16,
    rotate: -38.11
  }, "S")), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 544.63,
    x2: 415.28,
    y1: -3682.4,
    y2: -3828.7
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(374.18 -3024.8)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "203.01px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 0,
    y: 0,
    letterSpacing: -2
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 192.25,
    y: 0,
    letterSpacing: -15
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 338.62,
    y: 0,
    letterSpacing: 6
  }, "C")), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 570.35,
    y: -3040.6,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 705.83,
    y: -3040.6,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 855,
    y: -3040.6,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m-40.12-2997"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m489.78-2517.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 496.44,
    x2: 647.83,
    y1: -2516,
    y2: -2364.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: -186.35,
    x2: -49.05,
    y1: -2931.5,
    y2: -3073.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 1117.4,
    x2: 1264.3,
    y1: -3091.3,
    y2: -3226.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 535.99,
    cy: -3097.5,
    r: 741
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 534.22,
    cy: -3099.2,
    r: 583.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 5912.7,
    cy: -3097.9,
    r: 741
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 5910.9,
    cy: -3099.7,
    r: 583.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "5569.5 -3150.5 5569.5 -3111.8 5656.2 -3159.9 5743.1 -3111.8 5743.1 -3150.2 5656.3 -3199"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "5613.2 -3125.5 5656.3 -3149 5698.8 -3125.5 5656.3 -3100.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "5569.5 -3101.5 5569.5 -3051 5603.2 -3068.9 5603.2 -3120.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "5743.1 -3101.5 5743.1 -3050.6 5708.8 -3069.4 5708.8 -3120.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "5656.3 -3050.2 5698.8 -3074 5698.8 -3125.5 5656.3 -3100.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "5656.3 -3038 5656.3 -2999.9 5743.1 -3050.6 5708.8 -3069.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "5603.2 -3068.9 5656.3 -3038 5656.3 -2999.9 5569.5 -3051"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "5613.2 -3125.5 5613.2 -3074.6 5656.3 -3050.2 5656.3 -3100.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m5327.6-3074s4.3 240.97 198.75 412.93c145.38 128.57 346.74 144.69 346.74 144.69l151.39 151.11s-343.91 71.84-616.7-190.21c-180.8-173.69-217.48-376.45-217.48-376.45l137.3-142.07z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5915.9,
    cy: -3094.7,
    r: 600.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.845 -.5348 .5348 .845 6250.5 -2490.1)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 80.43,
    y: -0.55,
    rotate: -5.79
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 137.53,
    y: -6.13,
    rotate: -10.86
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 203.64,
    y: -17.82,
    rotate: -17.79
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 304.35,
    y: -51.38,
    rotate: -25.53
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 377.21,
    y: -86.04,
    rotate: -32.82
  }, "H")), /*#__PURE__*/React.createElement("circle", {
    cx: 5915.9,
    cy: -3094.7,
    r: 600.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.93 .3677 -.3677 .93 6110.9 -3688.4)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 66.84,
    y: 0.03,
    rotate: 5.39
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 117.97,
    y: 4.56,
    rotate: 10.08
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 168.41,
    y: 13.73,
    rotate: 13.52
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 192.03,
    y: 17.37,
    rotate: 18.92
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 282.12,
    y: 48.93,
    rotate: 26.3
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 340.09,
    y: 77.13,
    rotate: 32.44
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 397.96,
    y: 113.68,
    rotate: 38.58
  }, "X")), /*#__PURE__*/React.createElement("circle", {
    cx: 5913.5,
    cy: -3093.5,
    r: 605.58,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.229 -.9734 .9734 .229 5289.5 -3188.9)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "104.79px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 94.96,
    y: 0.93,
    rotate: 6.77
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 147.39,
    y: 6.74,
    rotate: 11.94
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 206.42,
    y: 18.78,
    rotate: 17.71
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 270.01,
    y: 39.18,
    rotate: 23.07
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 318.91,
    y: 59.05,
    rotate: 28.89
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 385.23,
    y: 95.44,
    rotate: 35.52
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 441.94,
    y: 135.72,
    rotate: 41.62
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 489.79,
    y: 177.6,
    rotate: 47.71
  }, "A")), /*#__PURE__*/React.createElement("circle", {
    cx: 5912.7,
    cy: -3097.9,
    r: 608.77,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.5393 .8421 -.8421 .5393 5297 -2764.3)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 98.12,
    y: -1.5,
    rotate: -5.02
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 111.59,
    y: -1.42,
    rotate: -8.44
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 181.11,
    y: -12.18,
    rotate: -11.86
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 199.88,
    y: -15.03,
    rotate: -15.5
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 267.48,
    y: -34.35,
    rotate: -19.14
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 288.76,
    y: -41.1,
    rotate: -22.34
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 350.27,
    y: -66.73,
    rotate: -27.7
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 406.93,
    y: -96.77,
    rotate: -32.96
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 458.29,
    y: -130.15,
    rotate: -38.11
  }, "S")), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 5921.3,
    x2: 5791.9,
    y1: -3682.9,
    y2: -3829.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(5750.8 -3025.3)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "203.01px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 0,
    y: 0,
    letterSpacing: -2
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 192.25,
    y: 0,
    letterSpacing: -15
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 338.62,
    y: 0,
    letterSpacing: 6
  }, "C")), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 5947,
    y: -3041.1,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 6082.5,
    y: -3041.1,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 6231.7,
    y: -3041.1,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m5336.5-2997.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m5866.4-2518.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 5873.1,
    x2: 6024.5,
    y1: -2516.4,
    y2: -2365.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 5190.3,
    x2: 5327.6,
    y1: -2932,
    y2: -3074
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 6494.1,
    x2: 6640.9,
    y1: -3091.8,
    y2: -3227.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 5912.7,
    cy: -3097.9,
    r: 741
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 5910.9,
    cy: -3099.7,
    r: 583.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st17",
    cx: 4120.2,
    cy: -3097.9,
    r: 741
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 4118.4,
    cy: -3099.6,
    r: 583.27
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "3777 -3150.4 3777 -3111.8 3863.8 -3159.9 3950.6 -3111.8 3950.6 -3150.2 3863.8 -3198.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "3820.7 -3125.4 3863.8 -3149 3906.3 -3125.4 3863.8 -3100.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "3777 -3101.4 3777 -3050.9 3810.7 -3068.9 3810.7 -3120.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "3950.6 -3101.4 3950.6 -3050.6 3916.3 -3069.4 3916.3 -3120.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "3863.8 -3050.1 3906.3 -3074 3906.3 -3125.4 3863.8 -3100.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "3863.8 -3037.9 3863.8 -2999.8 3950.6 -3050.6 3916.3 -3069.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "3810.7 -3068.9 3863.8 -3037.9 3863.8 -2999.8 3777 -3050.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "3820.7 -3125.4 3820.7 -3074.5 3863.8 -3050.1 3863.8 -3100.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m3999.4-3829.1l129.35 146.26s192.75-5.23 379.37 149.26c206.15 170.65 193.49 433.92 193.49 433.92l146.76-127.35s-33.03-255.82-260.15-445.31c-228.73-190.86-480.76-171.44-588.82-156.78z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4123.4,
    cy: -3094.6,
    r: 600.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.845 -.5348 .5348 .845 4458.1 -2490)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 80.43,
    y: -0.55,
    rotate: -5.79
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 137.53,
    y: -6.13,
    rotate: -10.86
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 203.64,
    y: -17.82,
    rotate: -17.79
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 304.35,
    y: -51.38,
    rotate: -25.53
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st13",
    x: 377.21,
    y: -86.05,
    rotate: -32.82
  }, "H")), /*#__PURE__*/React.createElement("circle", {
    cx: 4123.4,
    cy: -3094.6,
    r: 600.15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.93 .3677 -.3677 .93 4318.4 -3688.4)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 66.84,
    y: 0.03,
    rotate: 5.39
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 117.97,
    y: 4.56,
    rotate: 10.08
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 168.41,
    y: 13.73,
    rotate: 13.52
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 192.03,
    y: 17.37,
    rotate: 18.92
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 282.12,
    y: 48.93,
    rotate: 26.3
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 340.09,
    y: 77.13,
    rotate: 32.44
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "st14",
    x: 397.96,
    y: 113.68,
    rotate: 38.58
  }, "X")), /*#__PURE__*/React.createElement("circle", {
    cx: 4121,
    cy: -3093.4,
    r: 605.58,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.229 -.9734 .9734 .229 3497 -3188.9)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "104.79px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 94.96,
    y: 0.93,
    rotate: 6.77
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 147.39,
    y: 6.74,
    rotate: 11.94
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 206.42,
    y: 18.78,
    rotate: 17.71
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 270.01,
    y: 39.17,
    rotate: 23.07
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 318.91,
    y: 59.05,
    rotate: 28.89
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 385.23,
    y: 95.44,
    rotate: 35.52
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 441.95,
    y: 135.72,
    rotate: 41.62
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "st15",
    x: 489.79,
    y: 177.59,
    rotate: 47.71
  }, "A")), /*#__PURE__*/React.createElement("circle", {
    cx: 4120.2,
    cy: -3097.9,
    r: 608.77,
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.5393 .8421 -.8421 .5393 3504.5 -2764.2)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "105.34px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 98.12,
    y: -1.5,
    rotate: -5.02
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 111.59,
    y: -1.42,
    rotate: -8.44
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 181.11,
    y: -12.18,
    rotate: -11.86
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 199.88,
    y: -15.03,
    rotate: -15.5
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "st12",
    x: 267.48,
    y: -34.35,
    rotate: -19.14
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 288.76,
    y: -41.1,
    rotate: -22.34
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 350.27,
    y: -66.73,
    rotate: -27.7
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 406.93,
    y: -96.77,
    rotate: -32.96
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "st16",
    x: 458.29,
    y: -130.15,
    rotate: -38.11
  }, "S")), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 4128.8,
    x2: 3999.4,
    y1: -3682.8,
    y2: -3829.1
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(3958.4 -3025.2)",
    fontFamily: "'MuseoSlab-500'",
    fontSize: "203.01px"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 0,
    y: 0,
    letterSpacing: -2
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 192.25,
    y: 0,
    letterSpacing: -15
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "st4",
    x: 338.62,
    y: 0,
    letterSpacing: 6
  }, "C")), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 4154.5,
    y: -3041.1,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 4290,
    y: -3041.1,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 4439.2,
    y: -3041.1,
    width: 15.85,
    height: 15.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m3544.1-2997.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m4074-2518"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 4080.6,
    x2: 4232,
    y1: -2516.4,
    y2: -2365.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 3397.8,
    x2: 3535.1,
    y1: -2931.9,
    y2: -3074
  }), /*#__PURE__*/React.createElement("line", {
    className: "st19",
    x1: 4701.6,
    x2: 4848.4,
    y1: -3091.7,
    y2: -3227
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 4120.2,
    cy: -3097.9,
    r: 741
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st20",
    cx: 4118.4,
    cy: -3099.6,
    r: 583.27
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMucLogoCircle);
export default __webpack_public_path__ + "static/media/MucLogoCircle.7aa820b9.svg";
export { ForwardRef as ReactComponent };